<div class="search-results-header">
  <div class="search-container">
    <!-- Filter Sidebar Header -->
    <div class="filter-sidebar-header" [class.collapsed-sidebar]="!filterSidebarToggle()">
      <em class="icon-sidebar_close" (click)="onToggleFilters()"></em>
      <span *ngIf="filterSidebarToggle()">Filters</span>
      @if(filterSidebarToggle() && hasFilters(filters)) {
        <span class="clear-all" (click)="onClearFilters()">
          <em class="icon-close_small"></em>
          Clear All
        </span>
      }
    </div>

    <div class="filters-container">
        <div class="datepicker-container mobile-hidden">
          <div>Date Range</div>
          <app-datepicker
            [initialSelection]="initialDateRange"
            (selectedDates)="onDateRangeSelected($event)">
          </app-datepicker>
        </div>

        <!-- Search Form -->
        <!--
          TECH DEBT: The showSearchResults flag is a temporary solution to toggle
          the search functionality. This should be removed once the feature is stable.
        -->
        @if(showSearchResults) {
          <form
            [formGroup]="searchForm"
            autocomplete="off"
            (focusin)="onFocusInput(true)"
            (focusout)="onFocusInput(false)"
            [ngStyle]="{
              'border-color': !isFormFocused ? '#d1d1d1' : '#73A9D5',
              'margin-left': 'auto'
            }">
            <input
              type="text"
              class="search-input"
              placeholder="Search within results..."
              formControlName="searchInput"
              (keydown.enter)="onSubmitSearch()"
            />
            @if(!hasSearchInput) {
              <div class="search-button" (click)="onSubmitSearch()">
                <em class="icon icon-search"></em>
              </div>
            } @else {
            <div class="search-button" (click)="onClearSearch()">
              <em class="icon icon-close_small"></em>
            </div>
          }
          </form>
        }
    </div>
  </div>
</div>
